import * as React from 'react';
import {
    type Control,
    Controller,
    type FieldErrors,
    type FieldValues,
    type Path,
    type UseFormRegister,
} from 'react-hook-form';
import { FootnoteRegular, RowHeader, YStack } from 'smoothie';

import { SelectTransferAccountLineItem } from '../../../banking/components/transfers/TransferAccountLineItem';

interface ControlledDepositAccountSelectProps<
    TFieldValues extends FieldValues,
    TContext,
> {
    name: Path<TFieldValues>;
    control: Control<TFieldValues, TContext>;
    register: UseFormRegister<TFieldValues>;
    errors: FieldErrors<TFieldValues>;
    onPress: () => void;
    placeholder?: string;
    label?: string;
}

const ControlledDepositAccountSelect = <
    TFieldValues extends FieldValues,
    TContext,
>({
    name,
    control,
    register,
    label,
    placeholder,
    errors,
    onPress,
}: ControlledDepositAccountSelectProps<TFieldValues, TContext>) => {
    const isError = errors[name] != null;

    return (
        <Controller
            name={name}
            control={control}
            rules={{
                ...register,
            }}
            render={({ field: { value } }) => {
                return (
                    <YStack>
                        {label != null && (
                            <RowHeader
                                borderTopLeftRadius={16}
                                borderTopRightRadius={16}
                                title={label}
                                titleProps={{
                                    color: isError ? '$red1100' : '$black',
                                }}
                                marginBottom={0}
                            />
                        )}
                        <SelectTransferAccountLineItem
                            onPress={onPress}
                            depositAccount={value}
                            placeholder={placeholder}
                            showActionIcon
                        />
                        {errors[name] && (
                            <FootnoteRegular color="$red1000">
                                {errors[name]?.message}
                            </FootnoteRegular>
                        )}
                    </YStack>
                );
            }}
        />
    );
};

export default ControlledDepositAccountSelect;
